var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHappySvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "rgb(240, 240, 240)",
    height: "800px",
    width: "800px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 490 490",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M245,0C109.5,0,0,109.5,0,245s109.5,245,245,245s245-109.5,245-245S380.5,0,245,0z M245,449.3 c-112.6,0-204.3-91.7-204.3-204.3S132.4,40.7,245,40.7S449.3,132.4,449.3,245S357.6,449.3,245,449.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.9,288.8c-38.6,38.6-100.1,38.6-138.7,0c-8.3-8.3-20.9-8.3-29.2,0s-8.3,20.9,0,29.2c27.1,27.1,62.6,40.7,98,40.7 s70.9-13.6,99-40.7c8.3-8.3,8.3-20.9,0-29.2C335.7,280.4,323.2,280.4,314.9,288.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 155.3,
    cy: 189.7,
    r: 21
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 334.7,
    cy: 189.7,
    r: 21
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHappySvgrepoCom);
export default __webpack_public_path__ + "static/media/happy-svgrepo-com.a1ad193415e2aa51f2b498e7e8887f49.svg";
export { ForwardRef as ReactComponent };